import { createSlice } from '@reduxjs/toolkit';

import {
    fetchTableNames
} from "@/apis/config/tableNameApi";


const tableNameSlice = createSlice({
  name: 'tableNames',
  initialState: {
    options: [],    
    status: 'idle',   // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTableNames.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTableNames.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.options = action.payload.map((name) => ({
          value: name,
          label: name,
        }));
      })
      .addCase(fetchTableNames.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export default tableNameSlice.reducer;